import React, { createContext } from 'react'
import debounce from 'lodash.debounce'
import { Container } from '@app/components/Container'
import { RootStore } from '@app/models/RootStore'

const rootStore = new RootStore()
export const rootStoreContext = createContext(rootStore)
rootStore.initialize()

const resize = () => {
  rootStore.width = document.getElementById('f1times').offsetWidth
  rootStore.height = window.innerHeight
}

const debouncedResize = debounce(resize, 100)
window.addEventListener('resize', () => debouncedResize())
resize()

export const App = () => (
  <rootStoreContext.Provider value={rootStore}>
    <Container />
  </rootStoreContext.Provider>
)
